var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcedure3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 25.5,
    r: 18.5,
    fill: "#33878E"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 25.5,
    r: 18.0889,
    stroke: "url(#paint0_linear_1966_29091)",
    strokeOpacity: 0.83,
    strokeWidth: 0.822222,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1966_29091)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7,
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "url(#paint1_linear_1966_29091)",
    fillOpacity: 0.83,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.56162,
    y: 6.56162,
    width: 37.8768,
    height: 37.8768,
    rx: 18.9384,
    stroke: "url(#paint2_linear_1966_29091)",
    strokeOpacity: 0.83,
    strokeWidth: 0.876757,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2364 27.1018L22.8126 23.678L30.3905 16.1001C30.5731 15.9175 30.79 15.8262 31.0411 15.8262C31.2921 15.8262 31.509 15.9175 31.6916 16.1001L33.8143 18.2228C33.9969 18.4054 34.0882 18.6222 34.0882 18.8733C34.0882 19.1244 33.9969 19.3412 33.8143 19.5238L26.2364 27.1018ZM26.2364 24.4997L31.897 18.8619L31.0525 18.0174L25.4147 23.678L26.2364 24.4997ZM24.9582 32.2603L26.7842 30.4342H35.0012V32.2603H24.9582ZM19.5486 32.2603C18.8486 32.2603 18.1753 32.1233 17.5286 31.8494C16.8819 31.5755 16.3151 31.1951 15.8281 30.7081L21.8768 24.6823L24.2506 27.0561C24.4636 27.2692 24.631 27.5126 24.7527 27.7865C24.8745 28.0604 24.9353 28.3496 24.9353 28.6539C24.9353 28.9582 24.8745 29.2511 24.7527 29.5327C24.631 29.8142 24.4636 30.0614 24.2506 30.2745L23.8169 30.7081C23.33 31.1951 22.7632 31.5755 22.1164 31.8494C21.4697 32.1233 20.7964 32.2603 20.0964 32.2603H19.5486ZM19.5486 30.4342H20.0964C20.5529 30.4342 20.9942 30.3467 21.4203 30.1718C21.8463 29.9968 22.2192 29.7495 22.5387 29.4299L22.9724 28.9963C23.0637 28.905 23.1093 28.7984 23.1093 28.6767C23.1093 28.555 23.0637 28.4485 22.9724 28.3572L21.8768 27.2616L18.7726 30.3429C18.8943 30.3734 19.0236 30.3962 19.1606 30.4114C19.2975 30.4266 19.4269 30.4342 19.5486 30.4342Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1966_29091",
    x: -235.137,
    y: -236.139,
    width: 523.274,
    height: 523.277,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.250309
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.12886
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1966_29091"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1966_29091",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1966_29091",
    x1: 9.99231,
    y1: 12.7429,
    x2: 22.7695,
    y2: 40.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0865385,
    stopColor: "white",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346154,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697115,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "white",
    stopOpacity: 0.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1966_29091",
    x1: 9.99231,
    y1: 12.7429,
    x2: 22.7695,
    y2: 40.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352567,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1966_29091",
    x1: 9.99231,
    y1: 12.7429,
    x2: 16.5838,
    y2: 42.6093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "white",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346154,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697115,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "white",
    stopOpacity: 0.56
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcedure3);
export default __webpack_public_path__ + "static/media/procedure3.8d8651f8fcae917f4aa3b7db1c63688a.svg";
export { ForwardRef as ReactComponent };